import Paginate from 'react-paginate';
import PropTypes from 'prop-types';
import { ProductCard } from "../ProductCard";
import { Spinner } from '../elements';
import { useLouveApi, usePaginate } from '../../hooks';
import styles from './ProductGallery.module.css';

const ProductGallery = ({ url }) => {
  const { data, isFetching } = useLouveApi(url);
  const { handlePageClick, pagination } = usePaginate(data);

  return (
    <>
      {isFetching ?
        <div className="w-full flex items-center justify-center p-4">
          <Spinner color="#DB353A" size="h-12 w-12" />
        </div>
        :
        <>
          {(pagination.currentData && pagination.currentData.length === 0) &&
            <div className="w-full text-center text-2xl text-grey-700 p-4">
              <h4>
                No Product found
              </h4>
            </div>
          }
          {(pagination.currentData && pagination.currentData.length > 0) &&
            <div className={styles.responsiveGrid}>
              {pagination.currentData.map((d, i) => <ProductCard key={`${i + 1}`} {...d} />)}
            </div>
          }
        </>
      }
      {(pagination && pagination.currentData?.length > 16) &&
        <div class="flex items-center justify-end">
          <Paginate
            breakLabel={'...'}
            breakClassName={'mr-px font-bold'}
            breakLinkClassName={'mr-px'}
            pageCount={pagination.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            previousClassName={'hidden'}
            nextClassName={'hidden'}
            containerClassName={'btn-group flex items-center'}
            pageClassName={'md:flex border border-gray-400 hover:border-red-600 cursor-pointer transition duration-150 ease-in rounded btn px-2 mr-px bg-transparent hover:bg-transparent text-gray-400'}
            pageLinkClassName={'w-8 h-8 md:flex justify-center items-center hidden cursor-pointer'}
            activeClassName={'outline-none border border-red-600 shadow-md text-gray-700'}
            activeLinkClassName={'outline-none'}
          />
        </div>
      }
    </>
  );
}

// ProductGallery.defaultProps = {
 
// }
// { productName: 'Vlisco', productImage: '/assets/vlisco.png' },
// { productName: 'Ankara', productImage: '/assets/kaba.png' },
// { productName: 'Tartan', productImage: '/assets/tartan.png' },
// { productName: 'Toddler', productImage: '/assets/toddler.png' },
// { productName: 'Kaba', productImage: '/assets/kaba.png' },

ProductGallery.propTypes = {
  url: PropTypes.string,
}

export { ProductGallery };
